import { render, staticRenderFns } from "./ModalSelectGeneralStudyCategory.vue?vue&type=template&id=f63781c8&scoped=true&lang=pug&"
import script from "./ModalSelectGeneralStudyCategory.vue?vue&type=script&lang=ts&"
export * from "./ModalSelectGeneralStudyCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63781c8",
  null
  
)

export default component.exports